{
  "pageTitle": "Panel dostawców",
  "pageSubtitle": "Zarządzanie dostawcami",
  "search": { "placeholder": "Szukaj po nazwie..." },
  "table": {
    "name": "Nazwa",
    "email": "Email",
    "phone": "Telefon",
    "isInternal": "Wewnętrzny",
    "mediaUnitCount": "Nośniki",
    "actions": ""
  },
  "actions": {
    "addSupplier": "Dodaj dostawcę",
    "edit": "Edytuj",
    "delete": "Usuń",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "saving": "Zapisywanie...",
    "saved": "Zapisano",
    "saveFailed": "Nie udało się zapisać dostawcy",
    "deleted": "Dostawca został usunięty"
  },
  "dialog": {
    "createTitle": "Nowy dostawca",
    "editTitle": "Edytuj dostawcę",
    "close": "Zamknij",
    "fields": {
      "name": "Nazwa",
      "nameRequired": "Nazwa jest wymagana",
      "namePlaceholder": "Nazwa dostawcy",
      "nameTaken": "Dostawca o tej nazwie już istnieje",
      "email": "Email",
      "emailPlaceholder": "kontakt@dostawca.pl",
      "phone": "Telefon",
      "phonePlaceholder": "+48...",
      "shippingAddress": "Adres do wysyłki",
      "shippingAddressPlaceholder": "Adres wysyłki materiałów do dostawcy"
    },
    "suggestions": {
      "heading": "Istniejący dostawca",
      "noResults": "Brak wyników"
    }
  },
  "deleteDialog": {
    "titleSimple": "Usuń dostawcę",
    "titleWithUnits": "Usuń dostawcę ({{count}} nośników)",
    "descriptionSimple": "Ta operacja jest nieodwracalna.",
    "descriptionWithUnits": "Ten dostawca ma przypisane nośniki. Wybierz co z nimi zrobić.",
    "strategyAriaLabel": "Wybierz strategię usunięcia",
    "strategyDeleteUnits": "Usuń nośniki",
    "strategyReassign": "Przenieś do innego dostawcy",
    "targetSupplier": "Docelowy dostawca",
    "targetSupplierPlaceholder": "Wybierz dostawcę...",
    "targetSupplierSearchPlaceholder": "Szukaj dostawcy...",
    "targetSupplierNoResults": "Brak wyników",
    "confirmDelete": "Usuń"
  },
  "errors": {
    "supplierNumberCollision": "Kolizja numerów nośników przy przenoszeniu.",
    "hasActiveReservations": "Nie można usunąć: nośnik ma aktywną rezerwację.",
    "missingStrategy": "Wybierz strategię usunięcia."
  },
  "permissionDenied": "Nie masz uprawnień do tej strony.",
  "empty": {
    "title": "Brak dostawców",
    "description": "Dodaj pierwszego dostawcę.",
    "descriptionPermissionScope": "Przyczyną może być ograniczony zakres uprawnień."
  }
}
